import { QueueStats } from '../lib/api'

interface QueueChartProps {
  stats: QueueStats
}

export default function QueueChart({ stats }: QueueChartProps) {
  const total = stats.pendingJobs + stats.processingJobs
  const pendingPercent = total > 0 ? (stats.pendingJobs / total) * 100 : 0
  const processingPercent = total > 0 ? (stats.processingJobs / total) * 100 : 0

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Queue Status</h3>

      {/* Progress bar */}
      <div className="mb-6">
        <div className="flex justify-between text-sm text-gray-600 mb-1">
          <span>Pending: {stats.pendingJobs}</span>
          <span>Processing: {stats.processingJobs}</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
          <div className="h-full flex">
            <div
              className="bg-yellow-400"
              style={{ width: `${pendingPercent}%` }}
            />
            <div
              className="bg-blue-500"
              style={{ width: `${processingPercent}%` }}
            />
          </div>
        </div>
        <div className="flex justify-between text-xs text-gray-400 mt-1">
          <span>Pending</span>
          <span>Processing</span>
        </div>
      </div>

      {/* Stats grid */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="text-center">
          <p className="text-2xl font-bold text-green-600">{stats.completedLast24h}</p>
          <p className="text-xs text-gray-500">Completed (24h)</p>
        </div>
        <div className="text-center">
          <p className="text-2xl font-bold text-red-600">{stats.failedLast24h}</p>
          <p className="text-xs text-gray-500">Failed (24h)</p>
        </div>
        <div className="text-center">
          <p className="text-2xl font-bold text-gray-900">
            {Math.round(stats.avgWaitTimeMs / 1000)}s
          </p>
          <p className="text-xs text-gray-500">Avg Wait</p>
        </div>
        <div className="text-center">
          <p className="text-2xl font-bold text-gray-900">
            {stats.throughputPerHour.toFixed(1)}
          </p>
          <p className="text-xs text-gray-500">Jobs/Hour</p>
        </div>
      </div>
    </div>
  )
}
